// CSpell:ignore Elle

import { RouteType, useSdkContext } from "~/components/contexts";
export const useSitemap = () => {
  var _mobileSitemap$linksS;
  const {
    config
  } = useSdkContext();
  const mobileSitemap = {
    description: "Mobile sitemap display on the bottom of the page",
    links: [{
      isExternal: true,
      label: "Digital Subscription",
      url: {
        alias: config.subscribe.host
      }
    }, {
      isExternal: true,
      label: "Bundle Subscription",
      url: {
        alias: `${config.subscribe.host}/bundle`
      }
    }, {
      isExternal: true,
      label: "Group Subscriptions",
      url: {
        alias: `${config.subscribe.host}/group`,
        applicationId: "group-subscriptions"
      }
    }, {
      label: "Mobile Editions",
      url: {
        alias: "/mobile"
      }
    }, {
      isExternal: true,
      label: "ePaper",
      url: {
        alias: "/epaper"
      }
    }, {
      label: "RSS Feeds",
      url: {
        alias: "/rss"
      }
    }, {
      label: "Newsletters",
      url: {
        alias: "/newsletters"
      }
    }, {
      isExternal: true,
      label: "Buy SCMP Photos",
      url: {
        alias: "https://photo.scmp.com/",
        applicationId: "photo"
      }
    }, {
      isExternal: true,
      label: "Syndication & Licensing",
      url: {
        alias: "https://enterprise.scmp.com/licensing"
      }
    }],
    linksSecondary: [{
      label: "All Topics",
      url: {
        alias: "/topics"
      }
    }, {
      label: "All Authors",
      url: {
        alias: "/authors"
      }
    }, {
      isExternal: true,
      label: "SCMP Publishers",
      url: {
        alias: "https://corp.scmp.com/",
        applicationId: "scmp-publishers"
      }
    }, {
      label: "Policies and Standards",
      url: {
        alias: "/policies-and-standards",
        entityId: "3074375",
        entityUuid: "dd1bc258-b7b9-437c-bc4c-99130d8a5a3f",
        type: RouteType.Page
      }
    }, {
      label: "Privacy Policy",
      url: {
        alias: "/privacy-policy",
        entityId: "800172",
        entityUuid: "d1c18b93-cb6c-48a2-bf84-7c2acb96d4cc",
        type: RouteType.Page
      }
    }, {
      label: "Terms & Conditions",
      url: {
        alias: "/terms-conditions",
        entityId: "800173",
        entityUuid: "c18b91b9-6e24-45dc-ba05-974848666e4b",
        type: RouteType.Page
      }
    }, {
      label: "Commenting Guidelines",
      url: {
        alias: "/commenting-submission-guidelines",
        entityId: "3076709",
        entityUuid: "3460b664-d04c-44d0-83db-cec47ac0152c",
        type: RouteType.Page
      }
    }, {
      isExternal: true,
      label: "Help Center",
      url: {
        alias: "https://help.scmp.com/hc",
        applicationId: "help-center"
      }
    }, {
      isExternal: true,
      label: "Career with SCMP",
      url: {
        alias: "https://corp.scmp.com/work-for-us/",
        applicationId: "career-with-scmp"
      }
    }, {
      label: "Contact Us",
      url: {
        alias: "/contact-us",
        entityId: "800171",
        entityUuid: "b580e1d5-6698-42df-a1c2-1f7bdb2a0a04",
        type: RouteType.Page
      }
    }],
    name: "Mobile Footer sitemap"
  };
  const desktopSitemap = {
    description: "Sitemap display on the bottom of the page.",
    name: "Footer sitemap",
    sections: [{
      label: "Products & Services",
      links: mobileSitemap.links
    }, {
      label: "About Us",
      links: (_mobileSitemap$linksS = mobileSitemap.linksSecondary) !== null && _mobileSitemap$linksS !== void 0 ? _mobileSitemap$linksS : []
    }, {
      label: "Our Sites",
      links: [{
        isExternal: true,
        label: "Young Post",
        url: {
          alias: "/yp",
          applicationId: "yp"
        }
      }, {
        isExternal: true,
        label: "Posties",
        url: {
          alias: "/posties",
          applicationId: "posties"
        }
      }, {
        isExternal: true,
        label: "Serviced Apartments",
        url: {
          alias: "http://www.ays.com.hk/",
          applicationId: "serviced-apartments"
        }
      }, {
        label: "SCMP Cooking",
        url: {
          alias: "/cooking",
          applicationId: "scmp-cooking"
        }
      }, {
        isExternal: true,
        label: "Cosmopolitan",
        url: {
          alias: "https://www.cosmopolitan.com.hk",
          applicationId: "cosmopolitan"
        }
      }, {
        isExternal: true,
        label: "ELLE",
        url: {
          alias: "https://www.elle.com.hk",
          applicationId: "elle"
        }
      }, {
        isExternal: true,
        label: "Esquire",
        url: {
          alias: "https://www.esquirehk.com",
          applicationId: "esquire"
        }
      }, {
        label: "ELLE MEN",
        url: {
          alias: "https://www.ellemen.com.hk/ ",
          applicationId: "elle-men"
        }
      }, {
        isExternal: true,
        label: "Harper's BAZAAR",
        url: {
          alias: "https://www.harpersbazaar.com.hk",
          applicationId: "harpers-bazaar"
        }
      }, {
        isExternal: true,
        label: "CosMart" /*  Cspell:ignore Cosmart */,
        url: {
          alias: "https://www.cosmart.hk",
          applicationId: "cosmart"
        }
      }]
    }, {
      label: "Other",
      links: [{
        isExternal: true,
        label: "Advertising+",
        url: {
          alias: "http://advertising.scmp.com/",
          applicationId: "advertising-with-us"
        }
      }, {
        isExternal: true,
        label: "SCMP Events",
        url: {
          alias: "http://www.scmpevents.com",
          applicationId: "scmp-events"
        }
      }, {
        isExternal: true,
        label: "Enterprise+",
        url: {
          alias: "https://enterprise.scmp.com/",
          applicationId: "enterprise"
        }
      }, {
        label: "Learn",
        url: {
          alias: "/posties",
          applicationId: "posties"
        }
      }, {
        label: "SCMP PR Blog",
        url: {
          alias: "/topics/scmp-pr-blog",
          entityId: "512674",
          entityUuid: "b39eda92-a5a8-443c-8ebf-0d3989acb0f3",
          type: RouteType.Topic
        }
      }]
    }]
  };
  return {
    desktopSitemap,
    mobileSitemap
  };
};